import { render } from "./ByOrganization.vue?vue&type=template&id=48fc54c6&scoped=true"
import script from "./ByOrganization.vue?vue&type=script&lang=js"
export * from "./ByOrganization.vue?vue&type=script&lang=js"

import "./ByOrganization.vue?vue&type=style&index=0&id=48fc54c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fc54c6"]])

export default __exports__